import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import type { ShopSettings } from "@/lib/shop-settings";

export const DEFAULT_SHOP_SETTINGS: ShopSettings = {
  shop_name: "sosline",
  home_subtitle: "Mi smo online trgovina za Vaš ormar, novčanik i planetu",
  home_title: "sosline | Održiva moda po pristupačnim cijenama",
};

export function useShopSettings() {
  return useQuery<ShopSettings>({
    queryKey: ["settings"],
    queryFn: () => apiFetch<ShopSettings>("/api/settings"),
  });
}
